export default __webpack_public_path__ + "static/sortiment-sustenabil-label-df432161d7f353621ebbfd0f7150e012.png";